const DK = {
	"key": "value",
	/*			CHART-MAKER			*/
	"DATA_VIEW": "Data visning",
	"OBS_KPI": "KPI",
	"OBS_LOCAL_KPI": "KPI",
	"OBS_LOCAL_MONTH_KPI": "KPI",
	"OBS_SHARE": "Delte observationer",
	"SHARE_OBS": "Del observation",
	"SHARE_COMMENT": "Kommentar til observationen:",
	"LAST_RA_OBS_TABLE": "Seneste data tabel",
	"LAST_RA_TABLE": "Seneste RA tabel",
	"POINTS_LINE": "Point oversigt",
	"OBS_TYPES": "Observationer",
	"RA_COMMENTS": "Kommentare",

	"MONTHS": ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
	"OBS_LAST_YEAR": "Observationer sidste år",
	"SINCE_WEEK": "siden ugen før",
	"SHOW_EXT_OBS": "Vis eksterne observationer",
	
	"CLOSE"					: "Luk",
	"UNKOWN_ADDRESS": "Ukendt addresse",
	/*		DASHBOARD		*/
	"TOTAL_USERS"		: "Total brugere",
	"INFO"				: "Info",
	"MAP"				: "Kort",
	"LAST_ACTIVE": "Sidst aktiv",
	"LEAST_ACTIVE": "Mindst aktiv",
	"TOTAL_POINTS_O": "Total point",
	"POINTS_PR_REP": "Point pr. rep",
	"TARGET_MONTH": "Target pr. måned",
	"COMMENTS_AMOUNT": "Antal kommentarer",
	"ANSW_CHANGES_AMOUNT": "Antal svar-skift",
	"OBS_AMOUNT": "Antal observationer",
	"SHEET": "Ark",
	"QR_LOGIN": "QR login",
	"NO_DATA": "Ingen data fundet",
	"": "",
	"": "",
	"REMOVE_OBS_MSG": "Er du sikker på du vil slette observation #",
	"REMOVE_USR_MSG": "Er du sikker på du vil slette bruger #",
	"REMOVE_RA_MSG": "Er du sikker på du vil slette RA #",
	"NEVER": "Aldrig",
	"REPORTS"				: "Rapporter",
	"REPORT"				: "Rapport",
	
	"TOTAL_OBS"			: "Total observationer",
	
	"OBS_OWN_USR"		: "Obs. lavet af egne brugere",
	"OBS_OTH_USR"		: "Obs. lavet af andre brugere",
	"OBS_PR_USR"		: "Obs. pr bruger",
	"OBS_WARN"			: "Ubehandlede obs.",

	"TOTAL_RA"			: "Total Rapporter",
	"POINT_PR_USR"		: "Point pr. bruger",
	"POINT_PR_RA"		: "Point pr. rapport",
	"COMMENT_PR_USR"	: "Kommentarer pr. bruger",
	"GENEREL_VIEW"		: "Generel oversigt",
	"RA_OBS"			: "rapporter og observationer",
	"GENEREL_STATIS"	: "Generel statistik",
	"RA_NO_POINTS"		: "Rapporter uden point",
	"RA_20_POINTS"		: "Rapporter over 20 point",
	"OBS_LOW_PRIO"		: "Observationer med lav prioritet",
	"OBS_HIGH_PRIO"		: "Observationer med høj prioritet",
	"TOTAL_POINTS"		: "Total point pr.",
	"TOP_POINT_ADDR"	: "Adresser med flest point",
	"LOCATION"			: "Placering",
	"LATEST_RA"			: "Seneste besvarelser",
	"LATEST_COMMENTS"	: "Seneste kommentarer",
	"LATEST_USERS"		: "Seneste brugere",
	"TOP_5"				: "Top 5",
	"SET"				: "Sæt",
	"QUESTIONS"			: "Spørgsmål",
	"SINCE_LAST_WEEK"	: "siden sidste uge",
	"RA_TABLE_EXTRAS" 	: ["Aktuelt", "Periode", "Antal rapporter", "Rapporter pr. hverdag"],

	"LANGUAGE": "Sprog",

	/*			RA-PAGE			*/
	"ANSWERS"			: "Besvarelser",
	"BASIC_STAT_POINTS"	: "Statistik - Point over tid",
	"TIME"				: "Tid",
	"TIME2"				: "Tidspunkt",
	"EXPORT"			: "Exporter",
	"EXPORT_EXC"		: "Exporter til Excel",
	"ANALASYS"			: "Analyse",
	"GENEREL_INFO"		: "Overordnet information",
	"QUESTION"			: "Spørgsmål",

	"AMOUNT_IN_DEP": "Obs. i afd.",
	"DEPARTMENT_INFO": "Afdelings oversigt",

	/*			OBS-PAGE		*/
	"HEAND"				: "Hændelse",
	"KONS"				: "Konsekvens",
	"IMAGE_AMOUNT"		: "Antal billeder",
	"STATISTIC"			: "Statistik",
	"OBS_LATEST_30"		: "Observationer de sidste 30 dage",
	"OBSERVATION"		: "Observation",
	"OBSERVATIONS"	: "Observationer",
	"NOTES"				: "Noter",
	"IMAGES"			: "Billeder",
	"IMAGE"				: "Billede",
	"PRIORITY"			: "Prioritet",
	"TEMP_CHANGES"		: "Midlertidig iværktsatte tiltag",
	"STATUS"			: "Status",
	"STATUS_ARR"		: ["Handling påkrævet", "Handling igangsat", "Er ordnet", "Udenfor afdeling"],//["Afventer handling", "Handling igangsat", "Er ordnet"],
	"HISTORY"			: "Historik",
	"ACTION"			: "Handling",
	"ASSIGN_TO"			: "Tildel til",
	"ASSIGNED_TO"		: "Tildelt til",
	"YOU_ASSIGNED_OBS"	: "Du er blevet tildelt en observation",
	"CREATED_TEXT"		: "Oprettede observationen",
	"ASSIGNED_TO_USR"	: "Tildelte til kontakt",
	"UPDATED_STATUS"	: "Opdaterede status",
	"ADDED_COMMMENT"	: "Tilføjede kommentar",
	"RESPONSIBLE"		: "Ansvarlig",

	/*			USERS-PAGE		*/
	"EDIT_USER"			: "Ret bruger",
	"EDIT_DEPARTMENT"	: "Ret afdeling",
	"UPDATE"			: "Ret",
	"REPEAT"			: "Gentag",
	"PASS"				: "Kodeord",
	"EDIT"				: "Ændrer",
	"CREATE_USER"		: "Opret bruger",
	"CREATE_DEPARTMENT"	: "Opret afdeling",
	"CREATE"			: "Opret",
	"EDIT"				: "Ændrer",
	"DEPARTMENTS"		: "Afdelinger",
	"DEPARTMENT"		: "Afdeling",
	"DEPARTMENT_TO"		: "Afdeling til",
	"DEP_SHOW_HIDE"		: "Vis/skjul",
	"RA_WARN"			: "Send RA SMS påmindelse",

	/*			MENU 			*/
	"Moduler"			: "Moduler",
	"VIEW"				: "Oversigt",
	"Risk assesment"				: "Risk assessment",
	"Observationer"				: "Observationer",
	"Brugere"				: "Brugere",
	"Oversigt"				: "Oversigt",
	"Indbakke"				: "Indbakke",
	"Notifikationer"				: "Notifikationer",
	"Superuser"				: "Superuser",

	"CURRENT"				: "Nuværende",
	"OTHER_CONTACT"				: "Anden kontakt",


	/*		ERRORS 				*/

	"DEPART_UPDATED"	: "Afdelingen er opdateret!",
	"DEPART_ALREADY"	: "Afdelingen findes allerede!",
	"DEPART_CREATED"	: "Afdelingen er oprettet!",
	"DEPART_NOT_FOUND"	: "Afdelingen findes ikke!",

	"USER_NOT_FOUND"	: "Brugeren findes ikke!",
	"USER_UPDATED"		: "Brugeren er opdateret!",
	"USER_ALREADY"		: "Brugeren findes allerede!",
	"USER_CREATED"		: "Brugeren er oprettet!",
	"RA_NOT_FOUND"		: "Rapporten findes ikke!",
	"OBS_NOT_FOUND"		: "Observationen findes ikke!",
	"PASS_NOT_UPDATED"	: "De angivne koder er ikke ens, og er derfor ikke opdateret",


	"CHANGES_SAVED"		: "Ændrigerne er gemt!",

	"PASS_NOT_ALIKE": "De angivne kordeord er ikke ens",
	"MAILS_NOT_ALIKE": "De angivne mails er ikke ens",
	"USER_RANK_MISSING": "Brugerens rang skal angives",
	"DEPARTMENT_MISSING": "Brugerens afdeling skal angives",


	/*		Notifications 		*/
	"NOT_TITLE"		: "Notifikationer",
	"NEW_NOT"			: "Tilføj notifikation",
	"EDIT_NOT"		: "Ret notifikation",
	"2_DAYS"			: "2 dage",
	"TIME_SINCE_RA" : "Tid siden sidste rapport",
	"LAST_OBS" : "Sidste observation",
	"LAST_RA" : "Sidste rapport",
	"SAVE"				: "Gem",
	"TYPE"				: "Type",
	"OBS_TYPE"				: "Observation type",
	"EQUALS"				: "Er lig",
	"SEND"				: "Send",
	"TO"				: "Til",
	"NOTE"				: "Note",
	"NOTE_PLACE"	: "F.eks: Besked til Anders.",
	"TEST"				: "Test",
	"REMOVE"				: "Slet",
	"REMOVE_MSG"				: "Er du sikker på du vil slette denne?",
	"NOT_TYPES": {
		"NEW_REPORT": "Ny rapport",
		"NEW_OBS": "Ny observation",
		"NEW_OBS_TYPE": "Ny observation type",
		"NO_RAS": "Risk assessment påmindelse",
		"REPORT": "Opsamlings rapport",
	},
	"INTERVAL": "Interval",
	"NOT_SEND_TYPES": ["Mail", "SMS"],


	/*		Users 		*/
	"PHONE"				: "Telefon",
	"REPEAT_MAIL"	: "Gentag mail",
	"REPEAT_MAIL_NAME"	: "Gentag mail / brugernavn",
	"REPEAT_PASS"	: "Gentag kodeord",
	"RANK"				: "Rang",
	"RANKS"				: ["Alm. bruger", "Administrator"],
	"RA_SHEETS"		: "R.A skemaer",
	"UPDATE_USER"	: "Opdater bruger",
	"ADD_USER"		: "Tilføj bruger",


	/*		GENEREL TABLES 		*/
	"ADDRESS"			: "Addresse",
	"RISC"				: "Risiko",
	"CREATED_BY"		: "Oprettet af",
	"CREATEDBY"			: "Oprettet af",
	"LASTACTIVE"		: "Sidst aktiv",
	"DATE"				: "Dato",
	"MAIL"				: "Mail",
	"MAIL_NAME"			: "Mail / brugernavn",
	"NAME"				: "Navn",
	"FIRST_NAME"		: "Fornavn",
	"LAST_NAME"			: "Efternavn",
	"COMMENT"			: "Kommentar",
	"SHOW"				: "Vis",
	"SHOW_REPORT"		: "Vis rapport",
	"SHOW_OBS"			: "Vis observation",
	"DELETE_OBS"		: "Slet observation",
	"EXTERNAL_REP"		: "Ekstern rapport",
	"ID"				: "#",
	"TITLE"				: "Titel",
	"STARTED_DATE"		: "Startet",
	"DONE"				: "Afsluttet",
	"BY"				: "Af",
	"NOTES_AMOUNT"		: "Antal noter",
	"REP_AMOUNT"		: "Antal rapporter",
	"PUBLIC_RA"			: "Offentlig rapport",
	"TITLE"				: "Titel",
	"TITLE"				: "Titel",
	"ANSWER"			: "Svar",
	"SAND"				: "Sandsynlighed",
	"KONS"				: "Konsekvens",
	"CORRECT?"			: "Korrekt?",
	"ANSWER_CHANGED"	: "Svar ændret",
	"ANSWER"			: "Svar",
	"START_TIME"		: "Start tidspunkt",
	"END_TIME"			: "Afslutnings tidspunkt",
	"CUSTOMER"			: "Kunde",
	"SIGN_OUT"			: "Log ud",
	"ANSWER"			: "Svar",
	"ANSWER"			: "Svar",
	"ANON"			: "Anonym",
	"NOT_DONE"		: "Ikke afsluttet",
	"YES/NO"			: {
                    "1" : "Ja",
                    "2" : "Nej"
				  },
				  
	/*		LINKS 			*/
	"VIEW_LINKS": {
		"obs": "/reports/%CAT_ID%/%ID%",
		"ra": "/reports/%CAT_ID%/%ID%",
		"users": "/users/edit/%ID%",
	},

	/*		API 			*/
	"WRONG_LOGIN"		: "Forkert login information!",
	"NOT_LOGGED"		: "Du er ikke logget ind.",
	"RA_SAVED"			: "Rapporten er nu gemt. Du har fået tilsendt en kopi af rapporten.",
	"RA_SAVED_NO_M"	: "Rapporten er nu gemt.",
	"RA_SAVED_FOLLOW"	: "Rapporten er nu gemt. Husk at udfylde opfølgningen, når du er færdig.",
	"OBS_SAVED"			: "Opfølgningen er gemt.",
	"ERROR_CODE"		: "Der skete en fejl. Fejlkode:",
	"OBS_SAVED_MAIL"	: "Din observation er gemt. Du vil modtage et kopi af observationen på din mail.",
	"OBS_SAVED_NO_MAIL"	: "Din observation er gemt.",
	"AT"				: "hos",
	"POINT"				: "point",
	"MAIL_SENT"			: "Der er sendt en kopi til mail addressen.",
	"ERROR_RETRY"		: "Der skete en fejl, prøv igen!",

	"MAIL_NEW_TYPE"		: "Der er netop blevet oprettet en ny",
	"MAIL_TYPE"			: "af",
	"MAIL_FOUND_LINK"	: "Den kan findes på følgende link",

	/*	CHART-MAKER */
	"RA_POINTS_PIE": "RA point",
	"POINTS_LINE": "RA point over tid",
	"LAST_RA_TABLE": "Sidst afleveret RA",
	"RA_COMMENTS": "Mest brugte ord",

	"DATA_OPTIONS": {
		retrieve: true,
		"iDisplayLength": 50,
		"order": [[ 0, "desc" ]],
		"language": {
			"lengthMenu": "Vis _MENU_ pr side",
			"zeroRecords": "Intet fundet",
			"info": "Side _PAGE_ / _PAGES_",
			"infoEmpty": "Intet indhold",
			"search":         "Søg: ",
			 "paginate": {
				"first":      "Første",
				"last":       "Sidste",
				"next":       "Næste",
				"previous":   "Forrige"
			},
			"infoFiltered": "(filterer fra _MAX_ kolonner)"
		}
	},
};
export default DK;


// WEBPACK FOOTER //
// ./src/components/langs/phpDK.js